import React from 'react';

const HtmlDate = ({
    label = "Date",
    name,
    maxDate,
    minDate,
    onChange,
    value,
    type = "date",
    required = false,
    ...props
}) => {

    return (
        <>
            {
                label && <label htmlFor="name">
                    {label}
                    {required === true && <span style={{ color: 'red' }} > * </span>}
                </label>
            }
            {
                type !== "date" ?
                    <input
                        type="datetime-local"
                        name={name}
                        value={value}
                        onChange={onChange}
                        className="form-control"
                        max={maxDate}
                        min={minDate}
                        {...props}
                    />
                    :
                    <input
                        type="date"
                        name={name}
                        value={value}
                        onChange={onChange}
                        className="form-control"
                        max={maxDate}
                        min={minDate}
                        {...props}
                    />
            }

        </>
    );
};

export default HtmlDate;